<ng-container *ngIf="memberCard$ | async as memberCard; else loadingRef">
  <h2 class="accessibility-only">Member Card</h2>
  <div class="member-card text-white">

    <!-- Header: Name, subtitle, logo -->
    <div class="card-header-row d-flex justify-content-between align-items-start" *ngIf="memberDetails$ | async as memberDetails">
      <div class="card-info">
        <div class="card-name">{{ memberDetails.FirstName }} {{ memberDetails.Surname }}</div>
        <div class="card-subtitle">{{ memberCard.ProductCodeDisplayName }} - {{ memberCard.ExternalRefNumber }}</div>
      </div>
      <img class="card-logo" [src]="'logos/phxid-logo.svg' | contentAssetImage" alt="PHX ID" />
    </div>

    <!-- Payment Widget -->
    <fgb-payment-button></fgb-payment-button>

    <!-- Discounts -->
    <div class="card-discounts w-100">
      <div *ngIf="ecash$ | async as ecash" class="discount-row d-flex justify-content-between align-items-center">
        <span class="discount-label">{{ 'member.card.reward.credit' | translate }}</span>
        <span class="discount-value">{{ ecash | FortressCurrencyPipe }}</span>
      </div>
      <div *ngIf="memberCard.DiscountLevel" class="discount-row d-flex justify-content-between align-items-center">
        <span class="discount-label">{{ 'member.card.concession.discount' | translate }}</span>
        <span class="discount-value">{{ memberCard.DiscountLevel }}%</span>
      </div>
      <div *ngIf="memberCard.RetailDiscountLevel" class="discount-row d-flex justify-content-between align-items-center">
        <span class="discount-label">{{ 'member.card.team.shop.discount' | translate }}</span>
        <span class="discount-value">{{ memberCard.RetailDiscountLevel }}%</span>
      </div>
    </div>

  </div>
</ng-container>

<ng-template #loadingRef>
  <fgbcl-loading></fgbcl-loading>
</ng-template>
